// extracted by mini-css-extract-plugin
export default {"uploader":"FileDialog_uploader__0TL4i"};